<template>
  <div class="content_wrapper">
    <HeroBanner />
    <DisplayVideo />
    
    <FeaturesListing />
    <MoreFeaturesListing />

    <BottomCTA />
  </div>
  
  <!-- 
  
  
  -->
</template>

<script>
import HeroBanner from '@/components/main_page/HeroBanner.vue'
import DisplayVideo from '@/components/main_page/DisplayVideo.vue'
import BottomCTA from '@/components/main_page/BottomCTA.vue'
import FeaturesListing from '@/components/main_page/FeaturesListing.vue'
import MoreFeaturesListing from '@/components/main_page/MoreFeaturesListing.vue'

export default {
  name: 'PageContent',
  components:  {
    HeroBanner,
    DisplayVideo,
    BottomCTA,
    FeaturesListing,
    MoreFeaturesListing
  }
}
</script>

<style lang="scss" scoped>
  
</style>
